'use client';

import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { UIComponent } from '../core/components';
import { useLocalizedLinks } from '../core/hooks';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    turnstile: any;
  }
}

const TurnstileClient: UIComponent<{ siteKey?: string }> = ({ siteKey }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [widgetId, setWidgetId] = useState<string | null>(null);
  const searchParams = useSearchParams();
  const links = useLocalizedLinks();
  const redirect = searchParams.get('redirect');
  useEffect(() => {
    if (!siteKey) {
      return;
    }
    const load = () => {
      if (!window.turnstile || !ref.current) return;

      const id = window.turnstile.render(ref.current, {
        sitekey: siteKey,
        callback: (token: string) => {
          fetch('/user/antibot', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token }),
          }).then((res) => {
            if (res.ok) {
              if (redirect) {
                window.location.href = redirect;
                return;
              }
              window.location.reload();
            } else {
              links.antibotChallenge(window.location.href);
            }
          });
          // despues de verificar el token con el servidor
        },
        size: 'invisible',
        'response-field': false,
      });
      setWidgetId(id);
    };

    if (window.turnstile) {
      load();
    } else {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = load;
      document.head.appendChild(script);
    }
  }, [links, redirect, siteKey]);

  useEffect(() => {
    if (widgetId) {
      window.turnstile.execute(widgetId);
    }
  }, [widgetId]);

  if (!siteKey) {
    return null;
  }

  return <div ref={ref} />;
};

export default TurnstileClient;
